if (!customElements.get('tt-promotion-badge')) {
  customElements.define('tt-promotion-badge', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      const start = () => this.init();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.lifecycle.signal });
      else start();
    }

    init() {
      this.scope = this.closest('tt-color-card, .product-card-wrapper, product-info, .product__info-container');
      if (!this.scope || this.lifecycle.signal.aborted) return;
      this.variants = JSON.parse(this.querySelector('[data-tt-promo-variants]').textContent);
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.colorIndex = Number(this.dataset.colorIndex);
      this.isColorCard = this.scope.matches('tt-color-card');
      this.picker = this.scope.querySelector('variant-radios, variant-selects');
      this.sizePicker = this.scope.querySelector('tt-size-picker');
      this.sync = this.sync.bind(this);
      this.scope.addEventListener('change', this.sync, { signal: this.lifecycle.signal });
      this.observer = new MutationObserver(this.sync);
      if (this.isColorCard) this.observer.observe(this.scope, { attributes: true, attributeFilter: ['data-color'] });
      if (this.sizePicker) this.observer.observe(this.sizePicker, { attributes: true, attributeFilter: ['data-selected'] });
      this.sync();
    }

    sync() {
      let candidates = this.variants.filter(variant => variant[2]);
      let selectedId = '';
      if (this.isColorCard) {
        candidates = candidates.filter(variant => this.colorIndex < 0 || variant[3][this.colorIndex] === this.scope.dataset.color);
        selectedId = this.scope.querySelector('select[name="id"]')?.value || '';
        if (selectedId) candidates = candidates.filter(variant => String(variant[0]) === selectedId);
      } else if (this.picker) {
        const fieldsets = Array.from(this.picker.children).filter(element => element.tagName === 'FIELDSET');
        const options = fieldsets.length ? fieldsets.map(field => field.querySelector('input[type="radio"]:checked')?.value) : Array.from(this.picker.querySelectorAll('select')).map(select => select.value);
        if (this.sizePicker && this.sizePicker.dataset.selected !== 'true') options[this.sizeIndex] = undefined;
        candidates = candidates.filter(variant => variant[3].every((value, index) => !options[index] || value === options[index]));
      }
      const groups = new Set(candidates.map(variant => variant[1]).filter(Boolean));
      this.querySelectorAll('[data-offer]').forEach(offer => { offer.hidden = !groups.has(offer.dataset.offer); });
      this.hidden = groups.size === 0;
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
    }
  });
}
